export default "__VITE_ASSET__744d1b03__"